import { Injectable } from '@angular/core';

import { EnumEventTheme } from '../../../shared/constants/event-theme.constant';
import { EVENT_THEMES_CONFIG, IEventThemeConfig, IScheduleDate } from './event-theme.data';


@Injectable()
export class EventThemeHelper {


	/**------------------------------------------------------
	 * Get Action Event Theme
	 * > Iterate over all events and show effect conditionally
	 */
	getCurrentEventTheme(activeEventTheme: EnumEventTheme | null = null): IEventThemeConfig | null {

		//0 - get active theme if present
		if (activeEventTheme) {
			const activeTheme: IEventThemeConfig | undefined = EVENT_THEMES_CONFIG.find((theme: IEventThemeConfig) => theme.code === activeEventTheme);
			if (!activeTheme) throw new Error(`EventThemeHelper => getCurrentEvent => FATAL ERROR: ${activeEventTheme} is not supported.`);
			else return activeTheme;
		}

		//1 - loop over all event config
		for (const eventConfig of EVENT_THEMES_CONFIG) {

			//a. check if event should display manually
			if (eventConfig.condition.manual) return eventConfig;

			//b. continue if no schedule parameter is found
			if (!eventConfig.condition?.schedule) continue;

			//c. get scheduled event dates
			const showScheduleEvent: boolean = this.scheduleEventCheck(eventConfig.condition.schedule);
			if (showScheduleEvent) return eventConfig;
		}

		//2 - return null when there is no active theme and schedule theme
		return null;
	}

	//** Get date with current year */
	getDateWithCurrentYear(dateMonth: Date): Date {

		//0 - get date and month of the provided date
		const date	: number = dateMonth.getDate();
		const month	: number = dateMonth.getMonth();

		//1 - get current year
		const currentYear: number = new Date().getFullYear();

		//2 - return new date with date, month and current year
		return new Date(currentYear, month, date);
	}


	/**------------------------------------------------------
	 * Helper Function
	 */

	//** Check if event lies on current date */
	private scheduleEventCheck(eventSchedule: IScheduleDate): boolean {

		//0 - get start and end dates with current year
		const startDate	: Date = this.getDateWithCurrentYear(eventSchedule.start);
		const endDate	: Date = this.getDateWithCurrentYear(eventSchedule.end);

		//1 - is the schedule valid for the current date?
		const currentDate: Date = new Date();
		if (startDate <= currentDate && endDate >= currentDate) return true;

		//2 - not scheduled for the current date
		return false;
	}
}
